import { Box, styled } from '@ltvco/refresh-lib/theme';

export const CardContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: 720,
  borderRadius: 16,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  padding: 20,
  display: 'flex',
  flexDirection: 'column',
  gap: 0,
}));
